module.exports = __webpack_public_path__ + "static/media/arrow-right.31be4c0b.svg";